var map = {
	"./Article/NewsTemplate.jsx": [
		9144,
		144
	],
	"./Article/StandardTemplate.jsx": [
		8646,
		646
	],
	"./Errors/ErrorTemplate.jsx": [
		6634
	],
	"./Page/CitazioneTemplate.jsx": [
		2710,
		710
	],
	"./Page/ContattiTemplate.jsx": [
		4644,
		644
	],
	"./Page/FondazioneTemplate.jsx": [
		7083,
		83
	],
	"./Page/FullImageTitleTextTemplate.jsx": [
		1051,
		51
	],
	"./Page/GalleryDescriptionTextTemplate.jsx": [
		9051,
		432
	],
	"./Page/HeroTemplate.jsx": [
		8442
	],
	"./Page/HomeTemplate.jsx": [
		5647
	],
	"./Page/InfoHpTemplate.jsx": [
		474
	],
	"./Page/JointLabsTemplate.jsx": [
		4904,
		904
	],
	"./Page/LandingLabsTemplate.jsx": [
		6037,
		152,
		37
	],
	"./Page/MappaTemplate.jsx": [
		3337,
		152,
		226,
		337
	],
	"./Page/NewsHpTemplate.jsx": [
		9799
	],
	"./Page/NewsTemplate.jsx": [
		2655,
		655
	],
	"./Page/PeopleCarouselTemplate.jsx": [
		6961,
		961
	],
	"./Page/PressTemplate.jsx": [
		4745,
		745
	],
	"./Page/ProgettiHpTemplate.jsx": [
		9120
	],
	"./Page/ProgettiTemplate.jsx": [
		4160,
		160
	],
	"./Page/SchoolDetailTemplate.jsx": [
		5085,
		432,
		85
	],
	"./Page/SearchTemplate.jsx": [
		3502,
		152,
		720,
		502
	],
	"./Page/SideImgTitleTextTemplate.jsx": [
		7041,
		41
	],
	"./Page/SponsorCarouselTemplate.jsx": [
		7236,
		236
	],
	"./Page/StandardTemplate.jsx": [
		4609,
		609
	],
	"./Page/TitleTextGalleryTemplate.jsx": [
		8513,
		513
	],
	"./Page/TitleTextImageTemplate.jsx": [
		9836,
		836
	],
	"./Page/TitleTextStripTemplate.jsx": [
		7131,
		131
	],
	"./Page/TitleTextTemplate.jsx": [
		7723,
		723
	],
	"./Page/VisionTemplate.jsx": [
		3626,
		626
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1868;
module.exports = webpackAsyncContext;